module.exports = EchoEvents = {
    GROSS_WEIGHT_DATA_RECEIVED_EVENT: "GrossWeightDataReceivedEvent",
    UNIT_COUNTING_DATA_RECEIVED_EVENT: "UnitCountingDataReceivedEvent",
    CONTROL_WEIGHT_DATA_RECEIVED_EVENT: "ControlWeightDataReceivedEvent",
    PRODUCTION_LINE_ORDER_MOVED_EVENT: "ProductionLineOrderMovedEvent",
    PRODUCTION_STARTED_EVENT: "ProductionStartedEvent",
    PRODUCTION_STOPPED_EVENT: "ProductionStoppedEvent",
    PRODUCTION_PAUSED_EVENT: "ProductionPausedEvent",
    PRODUCTION_UNPAUSED_EVENT: "ProductionUnpausedEvent",
    RELOAD_WEB_CLIENT_EVENT: "ReloadWebClientEvent",
    QUEUE_RECALCULATION_EVENT: "QueueRecalculationEvent",
    ORDER_REFERENCE_STATE_CHANGED_EVENT: "OrderReferenceStateChangedEvent",
    CLOSE_USER_SESSION_EVENT: "CloseUserSessionEvent"
}
